import { useAppContext } from "../../../context";
import Footer from "../components/Footer";

// Wishlist Page Component (Inline for simplicity or create separate file)
export const Wishlist = () => {
    const { wishlist,toggleWishlist, addToCart } = useAppContext();

  
    return (
        <>
          { wishlist.length === 0 ? <div className="text-center py-20 text-gray-500">Your wishlist is empty.</div> :

        <div className="max-w-7xl mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-6">My Wishlist</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {wishlist.map(product => (
                    <div key={product.id} className="bg-white p-4 rounded-xl shadow-sm border">
                         <img src={product.images?.image} className="h-40 w-full object-contain mb-4" alt=""/>
                         <h3 className="font-bold line-clamp-1">{product.title}</h3>
                         <div className="flex justify-between mt-4">
                            <button onClick={() => toggleWishlist(product)} className="text-red-500 text-sm">Remove</button>
                            <button onClick={() => addToCart(product)} className="text-orange-500 font-bold text-sm">Add to Cart</button>
                         </div>
                    </div>
                ))}
            </div>
             
        </div> }
         <Footer />
        </>
        
    )
}
